import { datadogRum } from '@datadog/browser-rum';
import { CardType } from '@/home/HeroCardsReturnUser/Cards/LoadingCard';

export enum ActionNames {
  Finance = 'Clicked - Finance cta',
  Trade = 'Clicked - Trade cta'
}

export function fireAction(card: CardType) {
  switch (card) {
    case CardType.Finance:
      datadogRum.addAction(ActionNames.Finance);
      break;
    case CardType.Trade:
      datadogRum.addAction(ActionNames.Trade);
      break;
  }
}
